import type { Player } from "../types/game";

export const WLB_MAX = 10;
export const WLB_START = 7;
export const WLB_BURNOUT_THRESHOLD = 0;
export const WLB_BURNOUT_RECOVERY = 5;

export function clampWLB(value: number): number {
  return Math.max(0, Math.min(WLB_MAX, value));
}

export function drainWLB(player: Player, amount: number): Player {
  const newWLB = clampWLB(player.wlb - amount);
  return { ...player, wlb: newWLB };
}

export function restoreWLB(player: Player, amount: number): Player {
  const newWLB = clampWLB(player.wlb + amount);
  return { ...player, wlb: newWLB };
}

export function checkBurnout(player: Player): Player {
  if (player.wlb <= WLB_BURNOUT_THRESHOLD && !player.isBurntOut) {
    return { ...player, wlb: 0, isBurntOut: true, burntOutRoundsRemaining: 1 };
  }
  return player;
}

export function processBurnoutRecovery(player: Player): Player {
  if (!player.isBurntOut) return player;
  const remaining = player.burntOutRoundsRemaining - 1;
  if (remaining <= 0) {
    return { ...player, isBurntOut: false, burntOutRoundsRemaining: 0, wlb: WLB_BURNOUT_RECOVERY };
  }
  return { ...player, burntOutRoundsRemaining: remaining };
}

export function wlbColor(wlb: number): string {
  if (wlb >= 7) return "wlb-high";
  if (wlb >= 4) return "wlb-mid";
  return "wlb-low";
}
